import { render, staticRenderFns } from "./TermsWording.vue?vue&type=template&id=98e79cac&scoped=true"
import script from "./TermsWording.vue?vue&type=script&lang=ts"
export * from "./TermsWording.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e79cac",
  null
  
)

export default component.exports